import { TenantKey, TenantParentKey } from '@feature/pma-entity/pma-entity-types';

export class MftPreviewDialogResult {
  tenant: TenantKey;
  tenantParent: TenantParentKey;
  previewAsUserId: number;
  previewBy: string;
}
